import chest from '~/assets/icons/chest.svg';
import { Text } from '~/components/ui/Text';
import { StyledContainer } from './VehicleCardOnlyCase.styled';

const VehicleCardOnlyCase = ({ name }: { name?: string }) => (
	<StyledContainer>
		<Text className="label">Кейс “{name}”</Text>
		<img className="icon" src={chest} />
	</StyledContainer>
);

export { VehicleCardOnlyCase };
